import React from 'react';
import { GatsbySeo } from 'gatsby-plugin-next-seo';

function PageMetadata({ metadata }) {
	const props = {
		...metadata,
	};

	return <GatsbySeo {...props} />;
}
export default PageMetadata;
